import { ProductExternal } from '@nemuru-eng/js-api-client';

import { LoanListByApplicationTypeModule } from '@/components/modules/LoanListByProduct/LoanListByApplicationType';
import { MetricsProductExternalModule } from '@/components/modules/Metrics/MetricsProductExternal';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { ALL_CORE_APP_ROLES, ALL_CORE_APP_USER_TYPES, APP_USER_TYPES } from '@/config/config';
import { ApplicationType, PageScheme } from '@/config/types';

export const PAGE_CONSUMER_LOAN_LIST: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.CONSUMER_LOAN_LIST,
  showIfAllowedProduct: ApplicationType.CONSUMER_LOAN,
  schemesByRoles: [
    {
      roles: [...ALL_CORE_APP_ROLES],
      titleTextId: 'CONSUMER_LOAN_LIST',
      widgets: [],
    },
  ],
  sections: [
    {
      textId: undefined,
      module: (
        <MetricsProductExternalModule
          permissions={{
            view: [APP_USER_TYPES.SUPER_ADMIN, APP_USER_TYPES.ADMIN],
          }}
          productExternal={ProductExternal.CONSUMER_LOAN}
        />
      ),
    },
    {
      textId: undefined,
      module: (
        <LoanListByApplicationTypeModule
          permissions={{
            view: ALL_CORE_APP_USER_TYPES,
          }}
          applicationType={ApplicationType.CONSUMER_LOAN}
        />
      ),
    },
  ],
};
